import { createEvent, createStore } from 'effector'

export const actions = {
  setHelpVideos: createEvent<TutorialResponse[]>('setHelpVideos'),

  reset: createEvent('reset'),
}

const initialState: HelpState = {
  helpVideos: [],
}

export const store = createStore<HelpState>(initialState, { name: 'help' })
  .on(actions.setHelpVideos, (s, helpVideos) => ({ ...s, helpVideos }))
  .on(actions.reset, (s) => initialState)
